import packageJson from '../../package.json';

export class AppSettingsUrlBase {
	public static get version() { return packageJson.version; }

	public static debugApiUrl = 'https://localhost/'
	public static releaseApiUrl = 'https://api.marktools.net/'

	public static AppName = document.title;
	public static appDefaultUrl = '/';
	public static adminUrl = 'admin';
	public static DiscordLink = "https://discord.gg/BCfMJXgWDm";
	public static EmailLink = "mailto:support@marktools.net";
	public static TelegramLink = "https://t.me/marktools_support";
	public static YouTubeLink = "https://www.youtube.com/@mark-tools/";
	public static AuthUrl = {
		rootUrl: '',
		defaultUrl: '',
		loginUrl: 'auth'
	};
}

